export default "__VITE_ASSET__DDcB3bWh__"